import { applyFilters, doRequest } from "./helpers";

export default class FeatureFlagService {
  static async list(filters = null, { suppressForbiddenModal } = {}) {
    let path = "/feature_flag/";
    path = applyFilters(filters, path);
    return doRequest("GET", path, { suppressForbiddenModal });
  }

  static async get(flagId) {
    return doRequest("GET", `/feature_flag/${flagId}`);
  }

  static async create(data) {
    return doRequest("POST", "/feature_flag/", { data });
  }

  static async update(flagId, data) {
    return doRequest("PUT", `/feature_flag/${flagId}`, { data });
  }

  static async delete(flagId) {
    return doRequest("DELETE", `/feature_flag/${flagId}`);
  }

  static async effective() {
    return doRequest("GET", "/feature_flag/effective");
  }
}
